module.exports = __webpack_public_path__ + "static/media/ddl-arrow.0bcac827.svg";